import { CandidateWaitingRoomStatus } from "@/types";

const statusLabelMap: Record<CandidateWaitingRoomStatus, string> = {
  New: "New",
  "Invited to Apply": "Invited to Apply",
  "Application Under Review": "Application Under Review",
  Interviewing: "Video Interviewing",
  "Interview Under Review": "Video Interview Under Review",
  "Ready For MAP": "Ready For MAP",
  "Taking/Sent MAP": "Taking/Sent MAP",
  "MAP Under Review": "MAP Under Review",
  Joined: "Joined",
  "Dropped out": "Dropped out",
  Rejected: "Rejected",
};

const candidateStatusToLabel = (status: CandidateWaitingRoomStatus) =>
  statusLabelMap[status];

export default candidateStatusToLabel;
